import type { ReviewQueueItem, ReviewSubjectFilter } from '@/api/studio-production'

export function reviewItemKey(item: ReviewQueueItem): string {
  return `${item.item_type}:${item.public_id}`
}

export function reviewItemTitle(item: ReviewQueueItem): string {
  return item.title?.trim() || item.slug?.trim() || item.public_id
}

export function isReviewShotItem(item: ReviewQueueItem): boolean {
  return item.item_type === 'shot'
}

export function isReviewAssetItem(item: ReviewQueueItem): boolean {
  return item.item_type === 'asset'
}

export function usesAssetReviewLayout(
  filter: ReviewSubjectFilter,
  selected: ReviewQueueItem | null,
): boolean {
  if (selected) return isReviewAssetItem(selected)
  if (filter === 'all' || filter === 'shot') return false
  return true
}

export function reviewItemSubjectType(item: ReviewQueueItem): string {
  if (item.subject_type) return item.subject_type
  return isReviewShotItem(item) ? 'shot' : 'prop'
}

export function filterReviewQueue(
  items: ReviewQueueItem[],
  filter: ReviewSubjectFilter,
): ReviewQueueItem[] {
  if (filter === 'all') return items
  return items.filter((item) => reviewItemSubjectType(item) === filter)
}

export function reviewStatusTone(
  item: ReviewQueueItem,
): 'amber' | 'emerald' | 'indigo' | 'violet' | 'default' {
  if (isReviewAssetItem(item)) {
    switch (item.status) {
      case 'review':
        return 'violet'
      case 'ready':
        return 'emerald'
      case 'draft':
        return 'indigo'
      default:
        return 'default'
    }
  }
  const map: Record<string, 'amber' | 'emerald' | 'indigo' | 'violet' | 'default'> = {
    draft: 'default',
    storyboarded: 'amber',
    in_progress: 'indigo',
    review: 'violet',
    approved: 'emerald',
  }
  return map[item.status] ?? 'default'
}
